export default __webpack_public_path__ + "static/media/ada-128.197b0b32.png";